import Vue from 'vue/dist/vue.min.js';
import store from './store';
import {specsTableTemplate, specTableLoadMore} from './spec-table';

const Specifications = () => {

    const specs = document.querySelectorAll('.specs .page-section__wrapper');

    let specsConstructor = (id) => {
        Vue.component('specifications-template', {
            data: function() {
                return {
                    selectedItem: null,
                    selectedId: null,
                    selectedUrl: null
                }
            },
            computed: {
                tagMetaSelect: function() {
                    return JSON.stringify({
                        "type": "document",
                        "category": "Product Data Sheets",
                        "action": "Download",
                        "label": this.selectedItem,
                        "documentId": this.selectedId
                    })
                }                
            },
            methods: {
                selectItem(e) {
                    let select = this.$refs.dropdown;
                    let text = select.options[select.selectedIndex].text;
                    let Id = select.options[select.selectedIndex].dataset.id;
                    this.selectedItem = text;
                    this.selectedId = Id;
                    if (e) {
                        this.selectedUrl = e.target.value;
                    } else {
                        this.selectedUrl = select.options[select.selectedIndex].value;
                    }
                    
                },
                submit(e) {
                    // console.log(e.target);
                    window.open(this.selectedUrl, '_blank');
                }
            },
            mounted() {
                this.selectItem();
            }
        });


        new Vue({
            el: `.specs-${id}`,
            store: store,
        }).$mount(`.specs-${id}`, true);
    }

    specsTableTemplate();
    specTableLoadMore();

    if (specs.length > 0) {
        specs.forEach((item, index) => {
            item.classList.add(`specs-${index}`);
            specsConstructor(index);
        })
    }

}

export default Specifications;